import React, { PureComponent } from 'react';
import cx from 'classnames';
import ButtonIcon from '../ButtonIcon';
import Icon from '../Icon';
import Tooltip from '../Tooltip';

class Input extends PureComponent {
  constructor() {
    super();
    this.onKeyDown = this.onKeyDown.bind(this);
    this.state = {
      showClearText: false,
    };
  }
  onKeyDown(e) {
    const { onEnterPress } = this.props;
    if (e.key === 'Enter' && onEnterPress) {
      onEnterPress(e);
    }
  }

  onClickClear = () => {
    const { onChange } = this.props;
    onChange({ target: { value: '' } });
  };

  onClickToggleClearText = () => {
    this.setState((prevState) => ({
      showClearText: !prevState.showClearText,
    }));
  };

  render() {
    const {
      autoComplete,
      accept,
      autoFocus,
      className,
      fullWidth,
      id,
      innerRef,
      kind,
      name,
      onBlur,
      onChange,
      placeholder,
      size,
      type,
      value,
      disabled,
      maxLength,
      wrapperClassName,
      onPaste,
      showClearButton = false,
      infoTooltip,
    } = this.props;
    const { showClearText } = this.state;
    const modifierClasses = {
      [`input--color-${kind}`]: kind,
      [`input--size-${size}`]: size,
      'input--full-width': fullWidth,
    };
    return (
      <div className={cx('input-wrapper', wrapperClassName)}>
        <input
          accept={accept}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          className={cx('input', modifierClasses, className)}
          data-1p-ignore="true"
          data-lpignore="true"
          disabled={disabled}
          id={id}
          maxLength={maxLength}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          onKeyDown={this.onKeyDown}
          onPaste={onPaste}
          placeholder={placeholder}
          ref={innerRef}
          type={showClearText && type === 'password' ? 'text' : type}
          value={value}
        />
        {infoTooltip && !value ? (
          <Icon
            className="input__icon"
            color="grey"
            kind="info-circle"
            tabIndex="-1"
            tooltip={infoTooltip}
            tooltipWrapperClassName="input__icon-tooltip-wrapper"
          />
        ) : null}
        {showClearButton && value ? (
          <ButtonIcon
            className="input__icon-button"
            icon={'cross'}
            onClick={this.onClickClear}
            tabIndex="-1"
          />
        ) : null}
        {type === 'password' && (
          <ButtonIcon
            className="input__icon-button"
            icon={showClearText ? 'eye-crossed' : 'eye'}
            onClick={this.onClickToggleClearText}
            tabIndex="-1"
          />
        )}
      </div>
    );
  }
}

Input.defaultProps = {
  type: 'text',
  className: '',
};

export default React.forwardRef((props, ref) => (
  <Input innerRef={ref} {...props} />
));
